import { Navigate, useParams } from "react-router-dom";

const LegacySeniorDetailRedirect = () => {
  const { seniorUserAccountId } = useParams();
  return <Navigate to={`/admin/users/seniors/${seniorUserAccountId ?? ""}`} replace />;
};

export default LegacySeniorDetailRedirect;
